module.exports = {
  "wxc-progress": {
    "backgroundColor": "#f2f3f4"
  },
  "progress": {
    "position": "absolute",
    "backgroundColor": "#FFC900"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-d642f082!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-progress/index.vue
// module id = 196
// module chunks = 0 1